/**
 * Dev-gated console wrapper.
 * --------------------------
 * Use `devLog(...)` instead of `console.log(...)` for any diagnostic that
 * should NOT ship to production. `console.error` / `console.warn` should
 * keep being used directly for real errors so they show in operator
 * dashboards and Sentry-style aggregators.
 *
 * Compile-time stripping: `process.env.NODE_ENV === 'production'` is
 * substituted by CRA/webpack at build time, so the function body becomes
 * dead-code-eliminated in the production bundle.
 */
const IS_DEV = process.env.NODE_ENV !== 'production';

export const devLog = (...args) => {
  if (IS_DEV) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};

export const devGroup = (label, ...args) => {
  if (IS_DEV) {
    // eslint-disable-next-line no-console
    console.groupCollapsed(label);
    args.forEach((a) => console.log(a));  // eslint-disable-line no-console
    console.groupEnd();  // eslint-disable-line no-console
  }
};

export default devLog;
